import MaterialPricesTable from '.'
import React from 'react'
import { Switch } from 'react-router-dom'
import SentryRoute from '@/components/SentryRoute'
import getPagePath from '@/utils/getPagePath'
import MaterialPricesCreate from './create'
import MaterialPricesEdit from './edit/[materialPriceId]'

export function MaterialPricesRoutes(props) {
  return (
    <Switch>
      <SentryRoute
        path={getPagePath(props, '/create/:materialPriceId')}
        render={(props) => (
          <MaterialPricesCreate
            {...props}
            materialPriceId={props.match.params.materialPriceId as string}
          />
        )}
      />
      <SentryRoute
        path={getPagePath(props, '/edit/:materialPriceId')}
        render={(props) => (
          <MaterialPricesEdit
            {...props}
            materialPriceId={props.match.params.materialPriceId as string}
          />
        )}
      />
      <SentryRoute
        path={getPagePath(props, '/create')}
        render={(props) => (
          <MaterialPricesCreate {...props} materialPriceId={null} />
        )}
      />
      <SentryRoute path={getPagePath(props)} component={MaterialPricesTable} />
    </Switch>
  )
}

export default MaterialPricesRoutes
